const styles = ({ screenSizes, typography }) => ({
  [`@media(max-width: ${screenSizes.mobileMax}px)`]: {},

  '& h4': {
    ...typography.h1,
  },
});

export default styles;
